module.exports = __webpack_public_path__ + "img/9.b3ae33b9.jpg";